import { NavLink } from "react-router-dom";
import { Home, Plus, MessageCircle, ClipboardList, Trophy, User } from "lucide-react";

const TAB_ITEMS = [
  { to: "/", icon: Home, label: "Feed" },
  { to: "/create", icon: Plus, label: "Create" },
  { to: "/chats", icon: MessageCircle, label: "Chat" },
  { to: "/activity", icon: ClipboardList, label: "Activity" },
  { to: "/leaderboard", icon: Trophy, label: "Board" },
  { to: "/profile", icon: User, label: "Me" },
];

export default function BottomTabs() {
  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 bg-cream border-t border-stone z-50">
      <div className="flex justify-around items-center h-16">
        {TAB_ITEMS.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/"}
            className={({ isActive }) =>
              `flex flex-col items-center gap-0.5 px-2 py-1 text-xs font-medium transition-colors ${
                isActive ? "text-terracotta" : "text-walnut-light"
              }`
            }
          >
            <Icon size={22} />
            <span>{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
